import { render } from "./FacultyCourseOutcomes.vue?vue&type=template&id=47188a28"
import script from "./FacultyCourseOutcomes.vue?vue&type=script&lang=js"
export * from "./FacultyCourseOutcomes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__